import { createFileRoute } from '@tanstack/react-router';

import { ComingSoonPage } from '@/components/coming-soon-page';

export const Route = createFileRoute(
  '/_authed/dashboard/l/$locationId/marketing/sequences'
)({
  component: () => (
    <ComingSoonPage
      title="Sequences"
      description="Journey sequences for marketing. Coming soon."
    />
  ),
});
